module.exports = __webpack_public_path__ + "img/zh_hk2.0ce57770.png";